import { useEffect, useState } from "react"
import { Button, Flex, Result, Spin, Typography } from "antd"
import { useNavigate, useSearchParams } from "react-router"
import { getSafeRedirectPath, ROUTER } from "~/common/router"
import { captureEntrySpm, getStoredSpm } from "~/common/analytics/spm"
import { useSessionStore } from "~/store/session"
import styles from "./index.css"

const { Text } = Typography

export const XqtCallback = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const initialized = useSessionStore((state) => state.initialized)
  const loginWithXqt = useSessionStore((state) => state.loginWithXqt)
  const [errorMessage, setErrorMessage] = useState("")
  const [retryCount, setRetryCount] = useState(0)
  const uid = searchParams.get("uid")?.trim() || ""
  const spm = searchParams.get("spm")?.trim() || ""
  const redirectPath = getSafeRedirectPath(searchParams.get("redirect"))

  useEffect(() => {
    captureEntrySpm()
  }, [spm])

  useEffect(() => {
    if (!initialized) return

    if (!uid) {
      setErrorMessage("登录链接缺少 uid 参数")
      return
    }

    let ignored = false

    const login = async () => {
      setErrorMessage("")

      try {
        const source = getStoredSpm()

        await loginWithXqt({
          code: uid,
          ...(source ? { source } : {}),
        })

        if (!ignored) {
          navigate(redirectPath, { replace: true })
        }
      } catch (error) {
        if (ignored) return

        setErrorMessage(
          error instanceof Error ? error.message : "登录失败，请稍后重试",
        )
      }
    }

    void login()

    return () => {
      ignored = true
    }
  }, [initialized, loginWithXqt, navigate, redirectPath, retryCount, uid])

  return (
    <Flex
      className={styles.page}
      align="center"
      justify="center"
    >
      {errorMessage ? (
        <Result
          status="error"
          title="登录失败"
          subTitle={errorMessage}
          extra={[
            <Button
              key="retry"
              onClick={() => setRetryCount((count) => count + 1)}
              type="primary"
            >
              重试
            </Button>,
            <Button
              key="home"
              onClick={() => navigate(ROUTER.HOME, { replace: true })}
            >
              返回首页
            </Button>,
          ]}
        />
      ) : (
        <Flex
          align="center"
          gap={16}
          vertical
        >
          <Spin size="large" />
          <Text type="secondary">正在登录并跳转，请稍候...</Text>
        </Flex>
      )}
    </Flex>
  )
}
